import { handleActions } from 'redux-actions';
import { setCurrency } from '../actions/currencyActions';

const defaultState = null

export default handleActions(
    {
        [setCurrency](state, action) {
            return { ...state, ...action.payload }
        }
    },
    defaultState,
);
